import { render, staticRenderFns } from "./PayoutForm.vue?vue&type=template&id=5ada37ca&scoped=true&"
import script from "./PayoutForm.vue?vue&type=script&lang=js&"
export * from "./PayoutForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ada37ca",
  null
  
)

export default component.exports